<template>
<div>
  <div class="row">
    <div class="col-6">Product:</div>
    <div class="col-6">
      <select id='invoiceProductMenu' v-model="product" class="fullWidth">
        <option v-for="pr in products" v-bind:value="pr.ProductID">{{pr.ProductName}}</option>
      </select>
     </div>
  </div>

  <div class="row mt-3">
    <div class="col-6"># Licenses:</div>
    <div class="col-6"><input type='text' id='invoiceNumLicenses' v-model="numlicenses" /></div>
  </div>

  <div class="row mt-3">
    <div class="col-6">Term (Days) <button class="btn-transparent ib" @click='invoiceCartHelp(2)'><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button>:</div>
    <div class="col-3"><input type='text' id='invoiceTerm' v-model="term" /></div>
    <div class="col-3">
      <select id='invoiceTermDrp' v-model="termdrop" @change='invoiceFillTerm'>
        <option value='-'>---Select Term---</option>
        <option value='30'>1 month</option>
        <option value='90'>3 months</option>
        <option value='180'>6 months</option>
        <option value='365'>1 year</option>
        <option value='730'>2 years</option>
        <option value='1095'>3 years</option>
        <option value='1460'>4 years</option>
        <option value='1825'>5 years</option>
      </select>
      </div>
  </div>

  <div class="row mt-3">
    <div class="col-6">Termination Date <button class="btn-transparent ib" @click='invoiceCartHelp(1)'><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button>:</div>
    <div class="col-6"><v-date-picker v-model="terminationDate"></v-date-picker></div>
  </div>

  <div class="row mt-3" v-show="canOverridePrice===true">
    <div class="col-6">Price Per License:</div>
    <div class="col-6"><input type='text' id='invoicePrice' v-model="pricePerLicense" /></div>
  </div>

  <div class="row mt-3">
    <div class="col-6">
      Term Begins On <button class="btn-transparent ib" @click='invoiceCartHelp(2)'><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button>:
    </div>
    <div class="col-6">
      <select id='invoiceTermBegin' v-model="termBeginsOn">
        <option value='-'>---Select---</option>
        <option value='1'>Purchase Date</option>
        <option value='1'>Product Assignment</option>
        <option value='2'>Account Verification</option>
      </select>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
       <button class="btn btn-primary btn-short" @click="doSubmit">Submit</button>
    </div>
  </div>

  <b-modal ref="invHelp" title="Invoice Help">
     <div v-html="invHelpContent"></div>
  </b-modal>
</div>
</template>

<script>
   export default {
      name: "InvoicePurchase",
      props: ["products","pool","org","canOverridePrice"],
      data() {
        return {
          invHelpContent: null,
          numlicenses:null,
          product:null,
          term:null,
          termdrop:'-',
          terminationDate:null,
          pricePerLicense:null,
          termBeginsOn:"-"
        }
      },
      methods: {
        doSubmit() {
          if (this.product === null) {
            this.popDialog(1,"Please select a product");
            return;
          }

          if (this.term===null || this.term.length===1 || this.term<1) {
            this.popDialog(1,"Term is invalid");
            return;
          }

          if (this.numlicenses===null || this.numlicenses < 0) {
            this.popDialog(1,"Number of licenses is invalid");
            return;
          }

          if (this.termBeginsOn === '-') {
            this.popDialog(1,"Please select when the license is to begin");
            return;
          }

          if (this.terminationDate === null) {
            this.popDialog(1,"Termination date is invalid", "red");
            return;
          }

          if (!this.canOverridePrice) {
            this.pricePerLicense = null;
          }
          else {
            if (this.pricePerLicense===null || this.pricePerLicense<0.1) {
              this.popDialog(1,"Invoice price is required");
              return;
            }
          }

          var udata = JSON.parse(localStorage.getItem("udata"));

          var fields = {
            ClientID: this.emptyguid,
            LicensePoolID: this.pool.LicensePoolID,
            BStreetAddress1: this.org.Address1.StreetAddress1,
            BStreetAddress2: this.org.Address1.StreetAddress2,
            BCity: this.org.Address1.City,
            BState: this.org.Address1.State,
            BZip: this.org.Address1.Zip,
            BPhone: this.org.Address1.Phone,
            SStreetAddress1: this.org.Address1.StreetAddress1,
            SStreetAddress2: this.org.Address1.StreetAddress2,
            SCity: this.org.Address1.City,
            SState: this.org.Address1.State,
            SZip: this.org.Address1.Zip,
            SPhone: this.org.Address1.Phone,
            FirstName: udata.ClientName,
            LastName: "Invoice",
            CompanyName: this.org.OrganizationName,
            Description: "",
            TaxExemptCode: "",
            Shipping: "0",
            IsGift: "false",
            PromoCode: "",
            Products: []
          };

          fields.Products.push({
            "Key": this.product,
            "Value": {
              licenseType: 4,
              licenseHours: 0,
              licenseQuantity: this.numlicenses,
              licenseTerm: this.term,
              dvdQuantity: 0,
              customPrice: this.pricePerLicense,
              MaxExpDate: this.terminationDate,
              TriggerType: this.termBeginsOn,
              GoLive: 0
            }
          });
       
          this.apiCommand([
          {
            Operation: "Order",
            Function: "Add",
            Fields: fields
          }
          ]).then(response=> {
            if (response.CommandResult != null) {
              var cr = JSON.parse(response.CommandResult);
              if (cr.returnObjects[0].returnObject.indexOf("|||") > -1) {
                var oparts = cr.returnObjects[0].returnObject.split("|||");
                var op1 = JSON.parse(oparts[0]);

                this.apiCommand([
                  {
                    Operation: "Order",
                    Function: "InvoiceAndFill",
                    Fields: {
                      OrderID: op1.OrderID
                    }
                  }
                ]).then(r=> {
                  this.popDialog(0,"Invoice created. You should now have access to the new products");
                  this.$parent.goBack();
                }, function () { });
 
              }
              else {
                this.popDialog(1,cr.returnObjects[0].returnObject);
              }
            }
            else {
              this.popDialog(1,"A fatal problem occurred with creating the order");
            }
          }, function () { })
        },
        invoiceCartHelp(i) {
          var t = "";
          if (i === 0) {
            t = "This identifies how long each individual license will last. Terms are displayed in the amount of days the user will have access to the product. Terms cannot be longer than the termination date.";
          }
          else if (i === 1) {
            t = "This date determines when the entire batch of licenses will expire, including licenses that have not been assigned to an account. Termination dates cannot be shorter than the license term.";
          }
          else if (i === 2) {
            t = "Purchase Date: The license term will begin once the product license purchase is completed. This option can be used for both username and email based accounts.\n\r";
            t += "Product Assignment: The license term will begin once the product license is assigned to an account.This option can be used for both username and email based accounts.\n\r";
            t += "Account Verification: The license term will begin once the user verifies their account via email by creating a password. This option requires email based accounts.";
          }
          this.invHelpContent=t;
          this.$refs["invHelp"].show();
        },
        invoiceFillTerm() {
          if (this.termdrop!=='-') {
            this.term=this.termdrop;
          }
        },
        reset() {      
          this.numlicenses=null;
          this.term=null;
          this.terminationDate=null;
          this.pricePerLicense=null;
          this.termBeginsOn=null;
          if (this.products.length>0 && this.products[0].ProductID!==null) {
            this.products.unshift({
              ProductID: null,
              ProductName: "--- Select ---"
            })
          }
          this.product=null;
        }
      }
   }
</script>
